import { useTranslations } from 'next-intl';
import { getManagementPortal } from '@/app/apis';
import { toast } from '@/app/components/ui/use-toast';
import { openOrRedirect } from '@/app/utils/client';
import { useFetch } from './use-fetch';

export const useGotoManageStripe = () => {
  const t = useTranslations();
  const { loading, run: getManagement } = useFetch(getManagementPortal, {
    manual: true,
    onSuccess: ({ data, error }) => {
      if (error) {
        toast({
          type: 'warning',
          message: t('payments.getStripeUrlError'),
        });
        return;
      }
      if (data?.redirect_url) {
        openOrRedirect(data.redirect_url);
      }
    },
  });

  const handleGotoManageStripe = () => {
    getManagement();
  };

  return {
    loading,
    handleGotoManageStripe,
  };
};
